import React from "react";
import { ReactSVG } from "react-svg";
import { includes, filter } from "lodash";

import { PickerOptionProps } from "./types";
import { resolveIconSrc } from "@/utils/iconResolver";

import "./styles.scss";

export default function PickerItem({
  option,
  label,
  id,
  selectedOption,
  setSelectedOption,
  multiple,
  selector,
  iconSrc,
}: PickerOptionProps) {
  const handleSelectOption = (option: string) => {
    if (multiple) {
      const isOptionSelected = includes(selectedOption, option);

      isOptionSelected
        ? setSelectedOption(filter(selectedOption, (targetOption) => targetOption !== option))
        : setSelectedOption(Array.isArray(selectedOption) ? [...selectedOption, option] : [option]);
    } else {
      setSelectedOption(option);
    }
  };

  const getIconSrc = () =>
    resolveIconSrc(option, { iconSrc, fallback: `/svg/${selector}-${option}.svg` });

  const renderOption = () => {
    if (label) {
      return (
        <div className="Picker__item__container">
          <ReactSVG
            className="Picker__icon"
            src={getIconSrc()}
          />
          <span className="Picker__label">{label}</span>
        </div>
      );
    }

    return (
      <ReactSVG
        className="Picker__icon"
        src={getIconSrc()}
      />
    );
  };

  return (
    <li
      data-option={option}
      data-testid="Picker-item"
      data-qa={`${option}-button`}
      className={`Picker__item ${
        multiple
          ? includes(selectedOption, option)
            ? "Picker__item--active"
            : ""
          : selectedOption === option
            ? "Picker__item--active"
            : ""
      }`}
      key={id}
      onClick={() => handleSelectOption(option)}
    >
      {selector && renderOption()}
    </li>
  );
}
